<div class="position-relative">
  <a (click)="onPopupClose()" class="close mat-modal-close"><i class="material-icons">close</i></a>
  <mat-tab-group animationDuration="0ms" dynamicHeight [(selectedIndex)]="TabIndex"
    (selectedTabChange)="changeTab($event)" class="mat-tab-secondary">
    <mat-tab label="List">
      <ng-template matTabContent>
        <div class="align-items-center">
          <div class="search-input pl-2 mb-2">
            <input type="text" type="search" [(ngModel)]="SearchValue" class="form-control field-search W-98" maxlength="200"
              placeholder="Press ENTER to search" name="search2" (keyup.enter)="onSearch()" (input)="onInputChange($event)">
          </div>
        </div>
        <div [ngClass]="{'paddingMax' : this.showloader}">
        <app-page-tiny-loader *ngIf="showloader" (loaderClosed)="onLoaderClosed()"></app-page-tiny-loader>
      </div>
        <div class="table-responsive table-sticky" *ngIf="!showloader">
          <table class="table table-default table-hover">
            <thead>
              <tr>
                <th>Employee Name</th>
                <th>DOB</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Cost Center</th>
                <th>Business Unit</th>
                <th class="text-right">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let emp of EmployeeListData; let i = index;">
                <td matTooltip="{{ emp.firstName }} {{emp.lastName}}">
                  <a style="cursor: pointer;" role="button" href="javascript:void(0);" (click)="Select(emp)">
                    {{ emp.firstName?.length + emp.lastName?.length > 30 ? emp.firstName?.substring(0, 15) + '...' +
                    emp.lastName?.substring(0, 15): emp.firstName +' '+ emp.lastName }}
                  </a>
                </td>
                <td><span>{{formatDate(emp.dateOfBirth) }}</span></td>
                <td><span matTooltip={{emp.email}}>{{ emp.email?.length > 20 ? emp.email.substring(0, 20) + '...' :
                    emp.email}}</span></td>
                <td><span>{{emp.phoneNumber | phoneNumberFormat}}</span></td>
                <td><span>{{emp?.costCenter?.name}}</span></td>
                <td><span>{{emp?.businessUnit?.name}}</span></td>
                <td class="text-right">
                  <div class="d-flex align-items-center justify-content-end">
                    <span class="material-icons text-primary material-md-icon pointer" matTooltip="Edit"
                      (click)="Edit(emp)">edit</span>
                    <span class="material-icons closeicon pointer material-md-icon ml-2" matTooltip="Delete"
                      (click)="clickMethod(emp)">close</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="nofoundTxt" colspan="8" *ngIf="EmployeeListData.length < 1">
                  <h1><i class="far fa-frown mr-1"></i>&nbsp;No data found!</h1>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
        <mat-paginator #paginator *ngIf="EmployeeListData?.length > 0" [showFirstLastButtons]="true"
          [length]="Paginator.Length" [pageSize]="Paginator.PageSize" [pageSizeOptions]="Paginator.PageSizeOptions"
          (page)="setPagination($event)">
        </mat-paginator>
      </ng-template>
    </mat-tab>

    <mat-tab label="{{ Operation }}">
      <ng-template matTabContent>
        <div class="p-3">
          <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
            <div class="row">
              <div class="col-md-3">
                <label class="form-label">First Name <span class="req">*</span></label>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput type="text" id="firstName" placeholder="Enter First Name" name="FirstName"
                  formControlName="FirstName" pattern="^(?!\s*$).+" class="field-control"
                    (keypress)="removeSpaces($event)" (keypress)="omitSpecialCharNumber($event)" maxlength="30"
                    required>
                </mat-form-field>
                <div class="errorMsg Mt-3" *ngIf="Submitted">
                  <span *ngIf="formGroup.get('FirstName')?.errors?.['required']">First Name is required</span>
                </div>
              </div>
              <div class="col-md-3">
                <label class="form-label">Last Name <span class="req">*</span></label>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput type="text" id="lastName" placeholder="Enter Last Name" name="LastName"
                  formControlName="LastName" pattern="^(?!\s*$).+" class="field-control"
                    (keypress)="removeSpaces($event)" (keypress)="omitSpecialCharLastName($event)" maxlength="30"
                    required>
                </mat-form-field>
                <div class="errorMsg Mt-3" *ngIf="Submitted">
                  <span *ngIf="formGroup.get('FirstName')?.errors?.['required']">Last Name is required</span>
                </div>
              </div>
              <div class="col-md-3">
                <label class="form-label">Gender <span class="req">*</span></label>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select name="Gender" formControlName="Gender">
                    <mat-option value="" selected="selected">Select Gender</mat-option>
                    <mat-option value="M">Male</mat-option>
                    <mat-option value="F">Female</mat-option>
                  </mat-select>
                </mat-form-field>
                <div class="errorMsg Mt-3"
                  *ngIf="Submitted">
                  <span *ngIf="formGroup.get('Gender')?.value === undefined || formGroup.get('Gender')?.value  === null  || formGroup.get('Gender')?.value  === ''">Gender is required</span>
                </div>
              </div>

              <div class="col-md-3">
                <label class="form-label">Date of Birth </label>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput [matDatepicker]="dateOfBirthPicker" placeholder="Enter Date of Birth" [max]="maxDate"
                    name="DateOfBirth" formControlName="DateOfBirth" class="field-control" readonly>
                  <mat-datepicker-toggle matSuffix [for]="dateOfBirthPicker"></mat-datepicker-toggle>
                  <mat-datepicker #dateOfBirthPicker></mat-datepicker>
                </mat-form-field>
                <!-- <div class="errorMsg Mt-10" *ngIf="Submitted && (formModel.DateOfBirth === undefined || formModel.DateOfBirth === null)">
                              <span *ngIf="formModel.DateOfBirth === undefined || formModel.DateOfBirth === null">DOB is required</span>
                          </div> -->
              </div>

              <div class="col-md-3">
                <label class="form-label">Email <span class="req">*</span></label>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput type="email" id="email" placeholder="Enter Email" name="Email" directiveEmail
                  formControlName="Email" class="field-control" maxlength="100" required>
                </mat-form-field>
                <div class="errorMsg Mt-3" *ngIf="Submitted">
                  <span *ngIf="formGroup.get('Email')?.errors?.['required']">Email is required</span>
                  <div *ngIf="formGroup.get('Email')?.errors?.['invalidEmail']">Please enter a valid email address.</div>
                </div>
              </div>
              <div class="col-md-3">
                <label class="form-label">Phone Number </label>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput type="tel" id="phoneNumber" placeholder="Enter Phone Number" name="PhoneNumber"
                    minlength="12" maxlength="12" appPhoneNumber formControlName="PhoneNumber" class="field-control">
                </mat-form-field>
                <div class="errorMsg Mt-3" *ngIf="Submitted">
                                <span *ngIf="formGroup.get('PhoneNumber')?.errors?.['minlength']">Phone Number should be 10 digits</span>
                              </div>
              </div>
              <div class="col-md-3">
                <label class="form-label">Business Unit <app-on-page-loader [isLoading]="IsBuLoading" ></app-on-page-loader>
                  <span class="text-primary float-right ml-auto"
                    matTooltip="If you know the name then please type it otherwise press space">
                    <i class="info-icon"><img src="assets/images/info-icon.svg" /></i>
                  </span>
                </label>
                <mat-form-field appearance="outline" class="w-100">
                  <input type="text" id="BU" placeholder="Enter Business unit or space" name="BusinessUnitID" matInput
                  formControlName="BusinessUnitID" [matAutocomplete]="auto2" (input)="filterBu($event)" class="field-control">
                  <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayBU"
                  (closed)="onClosedCallback(filteredBu, BuListData, formGroup, 'BusinessUnitID', 'name')"
                  (optionSelected)="onSelectionCallback($event, formGroup, 'BusinessUnitID', 'name')">
                    <mat-option *ngFor="let option of filteredBu; let last = last" [value]="option"
                    [ngStyle]="{'border-bottom': last ? 'none' : '1px solid #ccc'}" class="text-wrap">
                      {{ option.name }}
                    </mat-option>
                    <mat-option *ngIf="filteredBu?.length === 0 && IsBuEnter" disabled class="no-data-option">
                      Business Unit Not Found!
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <!-- <small *ngIf="noDataBu" class="no-data-text">{{ConstantNoData}}</small> -->
              </div>
              <div class="col-md-3">
                <label class="form-label">Cost Center <app-on-page-loader [isLoading]="IsCcLoading"></app-on-page-loader>
                  <span class="text-primary float-right ml-auto"
                    matTooltip="If you know the name then please type it otherwise press space">
                    <i class="info-icon"><img src="assets/images/info-icon.svg" /></i>
                  </span>
                </label>
                <mat-form-field appearance="outline" class="w-100">
                  <input type="text" id="CC" placeholder="Enter Cost Center or space" name="CostCenterID" matInput
                  formControlName="CostCenterID" [matAutocomplete]="auto" (input)="filterCC($event)" class="field-control">
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCC"
                  (closed)="onClosedCallback(filteredCC, CCListData, formGroup, 'CostCenterID', 'name')"
                  (optionSelected)="onSelectionCallback($event, formGroup, 'CostCenterID', 'name')">
                    <mat-option *ngFor="let option of filteredCC; let last = last" [value]="option"
                    [ngStyle]="{'border-bottom': last ? 'none' : '1px solid #ccc'}" class="text-wrap">
                      {{ option.name }}
                    </mat-option>
                    <mat-option *ngIf="filteredCC?.length === 0 && IsCcEnter" disabled class="no-data-option">
                      Cost Center Not Found!
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <!-- <small *ngIf="noDataCc" class="no-data-text">{{ConstantNoData}}</small> -->
              </div>
              <div class="col-md-3" style="display: none;">
                <label class="form-label">Employment Start Date <span class="req">*</span></label>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput [matDatepicker]="employmentStartDatePicker" placeholder="Enter Employment Start Date"
                    readonly name="EmploymentStartDate" formControlName="EmploymentStartDate"
                    class="field-control">
                  <mat-datepicker-toggle matSuffix [for]="employmentStartDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #employmentStartDatePicker></mat-datepicker>
                </mat-form-field>
                <div class="errorMsg Mt-3" *ngIf="Submitted">
                  <span *ngIf="!formGroup.get('EmploymentStartDate')?.errors?.['required']">Employment Start Date is required</span>
                </div>

              </div>
              <div class="col-md-3" style="display: none;">
                <label class="form-label">Employment End Date <span class="req">*</span></label>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput [matDatepicker]="employmentEndDatePicker" placeholder="Enter Employment End Date"
                    readonly name="EmploymentEndDate" formControlName="EmploymentEndDate" class="field-control">
                  <mat-datepicker-toggle matSuffix [for]="employmentEndDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #employmentEndDatePicker></mat-datepicker>
                </mat-form-field>
                <div class="errorMsg Mt-3" *ngIf="Submitted">
                  <span *ngIf="!formGroup.get('EmploymentStartDate')?.errors?.['required']">Employment End Date is required</span>
                </div>
              </div>
              <div class="col-md-3">
                <label class="form-label">Designation </label>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput type="text" id="jobTitle" placeholder="Enter Designation" name="JobTitle"
                    (keypress)="removeSpaces($event)" (keypress)="omitSpecialChar($event)" formControlName="JobTitle" class="field-control" maxlength="50">
                </mat-form-field>
              </div>


              <div class="col-md-12" style="display: none;">
                <label class="form-label">Address<span class="req">*</span></label>
                <mat-form-field appearance="outline" class="w-100">
                  <textarea matInput id="address" placeholder="Enter Address" name="Address"
                  formControlName="Address" (keypress)="removeSpaces($event)"
                    (keypress)="omitValidateSpecialChar($event)" cdkAutosizeMinRows="3"
                    class="field-control resizeno" maxlength="255"></textarea>
                </mat-form-field>
                <div class="errorMsg" *ngIf="Submitted">
                  <span *ngIf="formGroup.get('FirstName')?.errors?.['required']">Address is required</span>
                </div>
              </div>
            </div>

            <div class="ml-auto text-center">
              <button type="submit" class="btn btn-primary  mr-2">{{ Operation }}</button>
              <button type="button" class="btn btn-secondary" (click)="gotoBack()">Cancel</button>
            </div>
          </form>

        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
